import { render, staticRenderFns } from "./Popconfirm.vue?vue&type=template&id=774d4c56&scoped=true&"
import script from "./Popconfirm.vue?vue&type=script&lang=js&"
export * from "./Popconfirm.vue?vue&type=script&lang=js&"
import style0 from "./Popconfirm.vue?vue&type=style&index=0&id=774d4c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774d4c56",
  null
  
)

export default component.exports